module.exports = __webpack_public_path__ + "static/2023-42f56995067db524387a8dda238a8e8c.png";